import { type FunctionComponent, useContext } from 'react';

import { ForecastContext, UserContext } from 'App';
import { NavLink } from 'react-router-dom';

import { canAccessDunningForecast } from 'components/DunningForecastPage/forecastAccess';
import i18n from 'i18n/i18n';
import { RIGHTS } from 'interfaces/Interfaces';
import { testAttribute } from 'util/Util';

import TaskStatusInfo from './TaskStatusInfo';

import './NavBar.style.sass';

const NavBar: FunctionComponent = () => {
  const { forecastProperty } = useContext(ForecastContext);

  function getNavItem(link: string, title: string) {
    return (
      <NavLink
        data-test-id={testAttribute('navm', 'nav.item', link)}
        to={link}
        end
        className="dunning-nav-container"
        // eslint-disable-next-line react/no-children-prop
        children={({ isActive }) => (
          <>
            <div className="nav-text">{title}</div>
            <div className={isActive ? 'arrow-up' : 'arrow-up-transparent'} />
          </>
        )}
      />
    );
  }

  return (
    <UserContext.Consumer>
      {user => (
        <div className="dunning-nav">
          {getNavItem('/#', i18n.t('title'))}
          {getNavItem('actions', i18n.t('action-page.title'))}
          {getNavItem('contract-state', i18n.t('contract-state.title'))}
          {user.rights.includes(RIGHTS.ACCESS_DUNNING_SELECTION) &&
            getNavItem('dunning-selection', i18n.t('dunning-selection.navbar-title'))}
          {canAccessDunningForecast(user, forecastProperty) &&
            getNavItem('dunning-forecast', i18n.t('dunning-forecast.title'))}
          {user.rights.includes(RIGHTS.ACCESS_ARCHIVE) && getNavItem('archive', i18n.t('archive.title'))}
          {user.rights.includes(RIGHTS.ACCESS_MANUAL_ACTIONS) &&
            getNavItem('manual-actions', i18n.t('manual-actions.title'))}
          {user.rights.includes(RIGHTS.ACCESS_SETTINGS) && getNavItem('settings', i18n.t('settings.title'))}
          {user.rights.includes(RIGHTS.ACCESS_ADMIN_PAGE) && getNavItem('admin', i18n.t('title_admin'))}
          <TaskStatusInfo />
        </div>
      )}
    </UserContext.Consumer>
  );
};

export default NavBar;
